import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Music2 } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-charcoal text-cream-100 pt-20 pb-8" data-id="element-82">
      <div className="max-w-7xl mx-auto px-6" data-id="element-83">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-84">
          {/* Brand column */}
          <div data-id="element-85">
            <Link to="/" className="inline-block mb-6" data-id="element-86">
              <Logo variant="white" className="h-16 w-auto" data-id="element-87" />
            </Link>
            <p className="font-medium text-cream mb-1" data-id="element-88">
              Milangela's Soul Garden
            </p>
            <p className="text-cream-100/80 mb-3" data-id="element-89">Branka Androjna</p>
            <a href="mailto:branka@milangelassoulgarden.com" className="text-rose hover:text-rose-100 transition-colors text-sm break-all" data-id="element-90">
              branka@milangelassoulgarden.com
            </a>

            <div className="mt-6" data-id="element-91">
              <Link to="/podcasts" className="inline-block px-5 py-2.5 border border-cream-100/30 rounded-full text-sm tracking-wide hover:bg-cream-100/10 transition-colors" data-id="element-92">
                Milangela's podcast
              </Link>
            </div>

            <div className="flex items-center gap-4 mt-8" data-id="element-93">
              <a href="#" aria-label="Facebook" className="text-cream-100/70 hover:text-cream transition-colors" data-id="element-94">
                <Facebook size={20} strokeWidth={1.5} data-id="element-95" />
              </a>
              <a href="#" aria-label="Instagram" className="text-cream-100/70 hover:text-cream transition-colors" data-id="element-96">
                <Instagram size={20} strokeWidth={1.5} data-id="element-97" />
              </a>
              <a href="#" aria-label="YouTube" className="text-cream-100/70 hover:text-cream transition-colors" data-id="element-98">
                <Youtube size={20} strokeWidth={1.5} data-id="element-99" />
              </a>
              <a href="#" aria-label="Spotify" className="text-cream-100/70 hover:text-cream transition-colors" data-id="element-100">
                <Music2 size={20} strokeWidth={1.5} data-id="element-101" />
              </a>
            </div>
          </div>

          {/* Newsletter column */}
          <div data-id="element-102">
            <h3 className="font-serif text-2xl text-cream mb-5" data-id="element-103">
              Get my newsletter
            </h3>
            <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-104">
              <input type="email" required placeholder="Your Email" aria-label="Your email" className="w-full bg-transparent border border-cream-100/30 rounded-full px-5 py-2.5 text-sm text-cream placeholder:text-cream-100/50 focus:border-rose focus:outline-none transition-colors" data-id="element-105" />
              <label className="flex items-start gap-2 text-xs text-cream-100/80 cursor-pointer" data-id="element-106">
                <input type="checkbox" className="mt-0.5 accent-rose" data-id="element-107" />
                <span data-id="element-108">
                  Agree to my{' '}
                  <Link to="#" className="text-rose hover:text-rose-100 underline-offset-2 hover:underline" data-id="element-109">
                    Privacy policy
                  </Link>
                </span>
              </label>
              <button type="submit" className="w-full border border-cream-100/30 hover:bg-cream-100/10 text-cream text-sm tracking-widest uppercase py-3 rounded transition-colors" data-id="element-110">
                Subscribe
              </button>
            </form>
          </div>

          {/* Sitemap column */}
          <div data-id="element-111">
            <h3 className="font-serif text-2xl text-cream mb-5" data-id="element-112">Explore</h3>
            <ul className="space-y-3 text-cream-100/80" data-id="element-113">
              <li data-id="element-114">
                <Link to="/milangela" className="hover:text-cream transition-colors" data-id="element-115">
                  Milangela's Story
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/podcasts" className="hover:text-cream transition-colors" data-id="element-117">
                  Podcasts
                </Link>
              </li>
              <li data-id="element-118">
                <Link to="/meditation" className="hover:text-cream transition-colors" data-id="element-119">
                  Meditation
                </Link>
              </li>
              <li data-id="element-120">
                <Link to="/creative-corner" className="hover:text-cream transition-colors" data-id="element-121">
                  Creative Corner
                </Link>
              </li>
              <li data-id="element-122">
                <Link to="/services" className="hover:text-cream transition-colors" data-id="element-123">
                  Services
                </Link>
              </li>
              <li data-id="element-124">
                <Link to="/blog" className="hover:text-cream transition-colors" data-id="element-125">
                  Blog
                </Link>
              </li>
              <li data-id="element-126">
                <Link to="/testimonies" className="hover:text-cream transition-colors" data-id="element-127">
                  Testimonies
                </Link>
              </li>
              <li data-id="element-128">
                <Link to="/contact" className="hover:text-cream transition-colors" data-id="element-129">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="border-t border-cream-100/15 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream-100/60" data-id="element-130">
          <p data-id="element-131">
            © {new Date().getFullYear()} Milangela's Soul Garden. All rights
            reserved.
          </p>
          <div className="flex items-center gap-5" data-id="element-132">
            <span data-id="element-133">Web Design: Mroz</span>
            <Link to="#" className="hover:text-cream-100 transition-colors" data-id="element-134">
              Privacy & Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}